import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';

import { Zone } from 'libs/ui';
import { openWindow } from 'store/actions/windows';
import { GridIcon, CaretIcon } from './icons';
import { Widget, WHead, WIco, WTitle, Chip, Caret, WBody, Occ, Bar, OccVal, Empty } from './widgets-dock.styled';

const fill = (freePct) => {
  if (freePct <= 0.08) return '#e0555f';
  if (freePct <= 0.25) return '#e0932f';
  return '#47b972';
};

export const OccupancyWidget = ({ open, onToggle }) => {
  const { t } = useTranslation();
  const boards = useSelector((store) => store.boards.boards, shallowEqual);
  const dispatch = useDispatch();

  const cfg = (window.config.objects && window.config.objects.boards) || [];

  const rows = cfg
    .map((b) => {
      const z = boards ? boards[b.zoneId] : null;
      if (!z) {
        return null;
      }
      const maximum = z.maximum || 0;
      const free = typeof z.free === 'number' ? z.free : Math.max(0, maximum - (z.current || 0));
      return { zoneId: b.zoneId, color: b.color, maximum, free };
    })
    .filter(Boolean);

  const totalFree = rows.reduce((s, r) => s + r.free, 0);

  const openZone = (r) => {
    dispatch(openWindow({ id: '0', type: 'single_board', data: { zoneId: r.zoneId, color: r.color } }));
  };

  return (
    <Widget>
      <WHead type="button" className={open ? '' : 'closed'} onClick={onToggle}>
        <WIco>
          <GridIcon />
        </WIco>
        <WTitle>{t('dock.Занятость по зонам')}</WTitle>
        {rows.length > 0 && <Chip className="ghost">{totalFree}</Chip>}
        <Caret className={open ? 'open' : ''}>
          <CaretIcon />
        </Caret>
      </WHead>
      {open && (
        <WBody>
          {rows.length === 0 && <Empty>{t('dock.Нет данных по зонам')}</Empty>}
          {rows.map((r) => {
            const freePct = r.maximum ? r.free / r.maximum : 0;
            const occPct = r.maximum ? Math.min(100, Math.round((1 - freePct) * 100)) : 0;
            return (
              <Occ key={r.zoneId} onClick={() => openZone(r)} title={t('dock.Открыть табло зоны') + ' ' + r.zoneId}>
                <Zone color={r.color} zoneId={r.zoneId} />
                <Bar>
                  <i style={{ width: occPct + '%', background: fill(freePct) }} />
                </Bar>
                <OccVal>
                  {r.free}/{r.maximum}
                </OccVal>
              </Occ>
            );
          })}
        </WBody>
      )}
    </Widget>
  );
};
